import Choices from 'choices.js';
import { Datalayers } from './Datalayers';

const SELECTOR = '.js-select';

const DEFAULT_CONFIG = {
    searchEnabled: false,
    itemSelectText: '',
};

function initSelects() {
    const SELECT_NODES = [...document.querySelectorAll(SELECTOR)];
    const returnComponent = false;

    if (SELECT_NODES) {
        SELECT_NODES.forEach((selectNode) => {
            initDropdown({ selectNode, config: DEFAULT_CONFIG, returnComponent });
        });
    }
}

function initDropdown({ selectNode, config, returnComponent = true }) {
    const CHOICES = new Choices(selectNode, config);
    const { name } = selectNode.dataset;
    const datalayers = new Datalayers();

    selectNode.addEventListener('externalValueChange', (e) => {
        CHOICES.setChoiceByValue(e.detail.value);
    });

    selectNode.addEventListener('choice', (e) => {
        datalayers.pushData({
            event: 'dropdown',
            eventcategory: 'dropdown',
            eventaction: name,
            eventlabel: e.detail.choice.label.trim(),
        });
    });

    return returnComponent ? CHOICES : false;
}

export { initSelects, initDropdown, DEFAULT_CONFIG };
